import React, { Component } from 'react'
import '../../assets/bootstrap/css/bootstrap.min.css'
import '../../assets/fonts/font-awesome.min.css'
import '../../assets/css/styles.css'
import { width } from '@mui/system';


export class Footers extends Component {
    render() {
        const footercss = { position: 'fixed', bottom: '0%', background: 'grey', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: "5px", backgroundColor: '#023047', color: '#007bff' };
        const footercopyright = { marginBottom: '0%' };

        return (
            <div>
                <footer>
                    <div style={footercss}>
                        <p style={footercopyright}>Copyright 2022</p>
                    </div>
                </footer>
            </div>
        )
    }
}

export default Footers
